import React from "react";
import { Grid } from "@mui/material";
import ProductItem from "../../../widgets/ProductItem";
import useApiEp from "../../../hooks/useApiEp";

const ProductFavorites = () => {
  const { data, isLoading, isError, error } = useApiEp(
    `/user/get-product-favorites`
  );
  return (
    <div>
      <Grid container spacing={3}>
        {data?.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <ProductItem viewMode={true} key={index} product={item} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default ProductFavorites;
